import EditarIcon from "../../assets/EditarIcon";

import {
  BarraFiltrosBtnEditar,
  BarraFiltroInputEditarContainer,
  BarraFiltroInputEditarHeader,
  BarraFiltroInputEditarBody,
  BarraFiltroInputSimulado,
  BarraFiltroIcon,
} from "./localStyle";

const BarraFiltroInputEditar = ({ title, value, onClick, icon }) => {
  return (
    <BarraFiltroInputEditarContainer>
      <BarraFiltroInputEditarHeader>
        <span>{title}</span>
      </BarraFiltroInputEditarHeader>
      <BarraFiltroInputEditarBody>
        <BarraFiltroInputSimulado>
          {icon && <BarraFiltroIcon>{icon}</BarraFiltroIcon>}
          <span>{value}</span>
        </BarraFiltroInputSimulado>
        <BarraFiltrosBtnEditar onClick={onClick}>
          <EditarIcon /> <span>Editar</span>
        </BarraFiltrosBtnEditar>
      </BarraFiltroInputEditarBody>
    </BarraFiltroInputEditarContainer>
  );
};

export default BarraFiltroInputEditar;
